import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { MspContent } from 'containers/Claims/components/MspContent'
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'

const MspDisclaimerBreadcrumb = () => {
  const { t } = useTranslation('msp')
  return (
      <BreadCrumb
        backButtonText={t('navigation.backToDisclaimer')}
        width="wide"
        navAriaLabel={t('navigation.backToDisclaimer')}
        backButtonLink="/claims/msp/disclaimer"
        siteActivityProps={{
          core: {
            component: 'Medicare Secondary Payer',
            coreClickData: {
              linkText: t('navigation.backToDisclaimer'),
              linkUrl: buildAbsoluteMedicareMyUrl('/claims/msp/disclaimer')
            },
            elementId: 'msp_backtodisclaimer_click'
          }
        }}
      />
  )
}

export const MspMainPage = () => {
  const { t } = useTranslation('msp')

  return (
    <>
      <MspDisclaimerBreadcrumb />
      <ContentLayout
        className="ds-u-padding-bottom--7"
        width="wide"
        heading={t('summary.headingMSP')}
        withPrintButton
      >
        <div className="ds-l-container">
          <MspContent />
        </div>
      </ContentLayout>
    </>
  )
}
